let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

if (items.length > 0) {
    items.forEach(item => {
        item.addEventListener("mouseover", () => {
            // Set the 'open' attribute on hover
            item.setAttribute("open", true);

            // Add mouseleave listeners to remove 'open' attribute
            const removeOpen = () => item.removeAttribute("open");

            // Check for submenu and attach leave listener to it
            const submenu = item.querySelector("ul");
            if (submenu) {
                submenu.addEventListener("mouseleave", removeOpen, { once: true });
            }

            // Attach leave listener to the main menu item
            item.addEventListener("mouseleave", removeOpen, { once: true });
        });
    });
}